import React from "react";
import clsx from "clsx";
import styles from "./_css/styles.module.css";

export function Title({ label }: { label: string }): JSX.Element {
    return <div className={clsx(styles.title, "mb_15")} dangerouslySetInnerHTML={{ __html: label }} />;
}
